import React from 'react';
import PropTypes from 'prop-types';
import { TabsList, ListItem } from './PlayTabList.styles';

const PlayTabList = (props) => {
    const { children, regTestItem, ...other } = props;

    return (
        <TabsList role="tablist" {...other}>
            {React.Children.map(children, (child) => {
                return (
                    <ListItem
                        role="tab"
                        aria-selected={child.props.children.props.isSelected}
                        key={child.key}
                        data-rt={regTestItem}
                    >
                        {child}
                    </ListItem>
                );
            })}
        </TabsList>
    );
};
PlayTabList.propTypes = {
    children: PropTypes.array,
    regTestItem: PropTypes.string,
};

export default PlayTabList;
